import React from "react";

const About =()=>{
    return(
        <p></p>
    )
}

export default About;